import React from 'react';
import { Link } from 'gatsby';

import { Socials, Wrapper } from './styles';
import InstagramIcon from '/static/icons/footer/instagram.svg';
import FacebookIcon from '/static/icons/footer/facebook.svg';

export const StayInTouch = () => {
  return (
    <Wrapper>
      <p>
        <b>Stay in touch</b>
      </p>
      <Socials>
        <a href="https://www.facebook.com/simplysayandmakesomonesday/"><FacebookIcon /></a>
        <a href="https://www.instagram.com/simplysayandmakesomeonesday/"><InstagramIcon /></a>
      </Socials>
    </Wrapper>
  );
};

export default StayInTouch;
